<template>
  <!-- Dropdown: Prioridad -->
  <b-dropdown
    variant="link"
    no-caret
    toggle-class="p-0"
    left
  >
    <!-- Prioridad seleccionada -->
    <template #button-content>
      <small class="text-muted mr-25"><b>Prioridad: </b></small>
      <span
        class="bullet bullet-sm mr-25"
        :class="`bullet-${notificationPriority(prioridadSelected)}`"
      />
      <span :class="`text-${notificationPriority(prioridadSelected)}`">{{ prioridadSelected }}</span>
    </template>

    <!-- Prioridades disponibles -->
    <b-dropdown-item
      v-for="prioridad in availablePriorities"
      :key="prioridad.value"
      @click="prioridadSelected = prioridad.value; $emit('add-priority', prioridad.value)"
    >
      <span
        class="bullet bullet-sm mr-1"
        :class="`bullet-${prioridad.color}`"
      />
      <span>{{ prioridad.value }}</span>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { ref, onMounted } from '@vue/composition-api'
import {
  BDropdown,
  BDropdownItem,
} from 'bootstrap-vue'
import { notificationPriority } from '@core/utils/filter'
import useNotificationComponse from '../useNotificationComponse'

export default {
  components: {
    BDropdown,
    BDropdownItem,
  },
  setup(_, { emit }) {
    const prioridadSelected = ref('MEDIA')
    const { availablePriorities } = useNotificationComponse()

    onMounted(() => emit('add-priority', prioridadSelected.value))
    const resetComponent = () => { prioridadSelected.value = 'MEDIA' }

    return {
      availablePriorities, prioridadSelected, notificationPriority, resetComponent,
    }
  },
}
</script>
